import { render, staticRenderFns } from "./Investing.vue?vue&type=template&id=32104ea8&"
import script from "./Investing.vue?vue&type=script&lang=js&"
export * from "./Investing.vue?vue&type=script&lang=js&"
import style0 from "./Investing.vue?vue&type=style&index=0&id=32104ea8&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports